export default "__VITE_ASSET__DS0FXUur__$_?url__"